import axios from "axios";
import { DeviceUUID } from "device-uuid";

import { BASE_URL_ORDRR } from "./apiUrls";
import {
  store,
  START_LOADING,
  STOP_LOADING,
  SAVE_LOGIN_DETAILS_SUCCEEDED,
} from "../Redux";
import { userLogout } from "../Redux/actions";

export const customAxios = axios.create({
  baseURL: BASE_URL_ORDRR,
});

customAxios.defaults.baseURL = BASE_URL_ORDRR;
customAxios.defaults.headers["Content-Type"] = "application/json";
customAxios.defaults.headers["deviceid"] = new DeviceUUID().get();

customAxios.interceptors.request.use(
  (config) => {
    // console.log("configggggg:", config.url, config);
    if (config?.data && config?.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    const token = store ? store.getState().authReducer.user_token ?? "" : "";
    config.headers.Authorization = "Bearer " + token;
    !config.disableLoading && store.dispatch({ type: START_LOADING });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const authInitialState = {
  is_error: false,
  register_details: [],
  user_details: null,
  user_token: "",
  is_registered: false,
};

customAxios.interceptors.response.use(
  (response) => {
    store.dispatch({ type: STOP_LOADING });
    if (response?.status === 401 || response?.data?.code === 401) {
      if (store) {
        store.dispatch(userLogout());
      } else {
        sessionStorage.clear();
        localStorage.clear();
      }
    }
    return response;
  },
  (error) => {
    store.dispatch({ type: STOP_LOADING });
    if (
      (error?.response?.status && error.response.status === 401) ||
      (error?.response?.data?.code && error.response.data.code === 401)
    ) {
      if (store) {
        store.dispatch(userLogout());
      } else {
        sessionStorage.clear();
        localStorage.clear();
      }
    }
    if (error?.response && error?.response?.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error?.message ?? "Something went wrong!");
  }
);

export const setAuthToken = (token) =>
  (customAxios.defaults.headers.Authorization = token);
